/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/


import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import auth from '../../auth'

import {
  NavLink,
  EmployerAccountSwitcher
} from '../'


class UserAccountMenu extends PureComponent {
  static propTypes = {
    user: PropTypes.string.isRequired,
    employerId: PropTypes.string.isRequired,
    employerName: PropTypes.string.isRequired,
    onClickOutside: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)

    this.userAccountMenuRef = React.createRef()
  }

  componentDidMount() {
    document.addEventListener("click", this.listenForClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.listenForClickOutside)
  }

  listenForClickOutside = (e) => {
    if (this.userAccountMenuRef.current.contains(e.target)) {
      // click is inside user account menu, stays open
      return
    }

    // click outside
    this.props.onClickOutside()
  }

  render() {
    return (
      <div
        ref={this.userAccountMenuRef}
        className='slds-m-top_xx-small slds-col_bump-left'
        style={{
          position: 'relative',
          zIndex: 10,
          backgroundColor: 'white',
          opacity: 0.9,
          fontSize: 'larger',
          float: 'right',
          borderLeft: '1px solid lightgrey',
          borderBottom: '1px solid lightgrey',
          borderRight: '1px solid lightgrey',
          boxShadow: '2px 3px 8px 0 rgba(0,0,0, .25)'
        }}>
        <div className="slds-m-around_large" style={{ lineHeight: 1.25 }}>
          <div className="slds-text-color_weak">
            {this.props.employerName}
          </div>
          <div>
            <b>{this.props.user}</b>
          </div>
        </div>
        {/* <div className="slds-m-around_large">
          <NavLink to="/os/?">
            Manage account
          </NavLink>
        </div> */}
        {localStorage.getItem('accessibleEmployerAccounts') !== 'undefined' &&
          JSON.parse(localStorage.getItem('accessibleEmployerAccounts')).length > 1 &&
          <div className="slds-m-around_large">
            <div className="slds-text-color_weak">
              Switch accounts?
            </div>
            <EmployerAccountSwitcher
              currentEmployerId={this.props.employerId}
              onSelectionClick={this.props.onEmployerSwitchClick}
              switchOnSelect={true}
            />
          </div>
        }
        <div className="slds-p-around_large slds-border_top">
          <NavLink
            to="/os"
            className="slds-text-color_weak"
            onClick={(e) => {
              auth.logout()
              sessionStorage.clear()
              this.props.history.push({ state: {} })
              // NOTE: intentionally logging out will clear location.state which will mean that
              // on logging back in the user won't necessarily see the last page they were on before
              // they logged out.  Picsa employees in this case will see the case listing page.
              // If the user though gets logged out via idle timeout, they can log in and will see
              // the last page they were on before being automatically logged out.
            }}>
            <b>Log out</b>
          </NavLink>
        </div>
      </div>
    )
  }
}

export default withRouter(UserAccountMenu)



// WEBPACK FOOTER //
// ./src/components/user-account-menu/index.js